import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { FC } from "react";

import CasaLogo from "../../../../shared/logo/CasaLogo";
import BrandAndBusinessSelect from "../BrandAndBusinessSelect/BrandAndBusinessSelect";
import InstantSearch from "../InstantSearch/InstantSearch";
import HotkeySettingsButton from "../../../../features/HotkeySettings/components/HotkeySettingsButton";
import UserAccount from "../UserAccount/UserAccount";
import styles from "./Navbar.module.scss";
import useNavigationLink from "../../../../hooks/useNavigationLink";
import ChatButton from "../../../../features/Chan/ChatButton";
import { CasaAIProvider } from "../../../../features/CasaAI/context/CasaAI";
import { DraggableChatProvider } from "../../../../features/Chan";

interface NavbarProps {
  onToggleSidebar: () => void;
  onToggleChan?: () => void;
  hideSidebar?: boolean;
  showChan?: boolean;
}

const Navbar: FC<NavbarProps> = ({
  onToggleSidebar,
  hideSidebar = false,
  showChan = true,
}) => {
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down("xl"));
  const { fullScreenMode } = useNavigationLink();

  return (
    <AppBar
      id={styles.navbar}
      color="transparent"
      position="sticky"
      elevation={0}
      sx={{ bgcolor: "white" }}
    >
      <Toolbar className={styles.navbarContainer}>
        <Box className={styles.navLeft}>
          {!hideSidebar && (isMobileView || fullScreenMode) && (
            <IconButton onClick={onToggleSidebar}>
              <MenuIcon />
            </IconButton>
          )}
          <CasaLogo />
        </Box>
        <Box className={styles.navRight}>
          {showChan && (
            <CasaAIProvider>
              <DraggableChatProvider>
                <ChatButton />
              </DraggableChatProvider>
            </CasaAIProvider>
          )}
          <InstantSearch />
          <HotkeySettingsButton />
          <BrandAndBusinessSelect />
          <UserAccount />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
